/* eslint-disable @typescript-eslint/no-unused-vars */
import Web3 from "web3";
import { Contract } from "web3-eth-contract";
import { AbiItem } from "web3-utils";
import { web3 } from "../web3";

interface EthereumProvider {
  request: (args: { method: string }) => Promise<string>;
  send: (method: string) => Promise<void>;
  enable: () => Promise<string[]>;
  selectedAddress: string | null;
  networkVersion: string;
}

declare global {
  interface Window {
    ethereum: EthereumProvider;
  }
}

interface Web3Services {
  getAccounts: () => Promise<string[]>;
  getNetworkId: () => Promise<string | number>;
  enableMetamask: () => Promise<boolean>;
  getContractInstance: <T extends AbiItem[]>(
    contractAbi: T,
    contractAddress: string,
  ) => Promise<Contract<T>>;
}

export const web3Services: Web3Services = {
  async getAccounts(): Promise<string[]> {
    try {
      if (web3) {
        return await web3.eth.getAccounts();
      }
      return [];
    } catch (error) {
      return [];
    }
  },

  async getNetworkId(): Promise<string | number> {
    try {
      if (web3) {
        const networkId = await web3.eth.net.getId();
        return networkId.toString();
      }
      return "";
    } catch (error) {
      return "";
    }
  },

  async enableMetamask(): Promise<boolean> {
    try {
      if (typeof window !== "undefined" && window.ethereum) {
        await window.ethereum.request({ method: "eth_requestAccounts" });
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  },

  async getContractInstance<T extends AbiItem[]>(
    contractAbi: T,
    contractAddress: string,
  ): Promise<Contract<T>> {
    try {
      if (!web3) {
        throw new Error("Web3 is not initialized");
      }

      const contract = new web3.eth.Contract(contractAbi, contractAddress);
      if (!contract) {
        throw new Error("Failed to create contract instance");
      }

      return contract;
    } catch (error) {
      throw error;
    }
  },
};
